module.exports = "<p>\r\n  contact-us works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contact-us/contact-us.component.html
// module id = ./src/app/components/contact-us/contact-us.component.html
// module chunks = main